import { supOrgAccDetailsFun } from '../../../api/supportAdmin';

export const FetchOrgAccount = async ({ type, orgId }) => {
    try {
        const item = await supOrgAccDetailsFun(type, orgId);
        if (item.status === 200) {
            return item.data;
        } else {
            throw new Error('Failed to fetch organization data');
        }
    } catch (error) {
        console.error('FetchOrgAccount error:', error);
        throw error;
    }
};
